import ReactDOM from 'react-dom';
import ExternalToolDialog from './components/ExternalToolDialog/ExternalToolDialog';
import React, { createRef } from 'react';
const ensureToolDialogContainerId = 'external-tool-dialog-container';
export function ensureToolDialogContainerElem() {
  let dialogContainer = document.getElementById(ensureToolDialogContainerId);

  if (dialogContainer === null) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = ensureToolDialogContainerId;
    document.body.appendChild(dialogContainer);
  }

  return dialogContainer;
}
export function openToolDialogFor(toolHelper) {
  const dialogRef = /*#__PURE__*/createRef();
  const env = toolHelper.env;
  ReactDOM.render( /*#__PURE__*/React.createElement(ExternalToolDialog, {
    ref: dialogRef,
    env: env,
    iframeAllowances: env.ltiIframeAllowPolicy,
    resourceSelectionUrlOverride: env.resourceSelectionUrlOverride
  }), ensureToolDialogContainerElem(), () => {
    var _dialogRef$current;

    (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 ? void 0 : _dialogRef$current.open(toolHelper);
  });
}